import React from 'react';
import {
  Box,
  Typography,
  Button,
  Chip,
} from '@mui/material';
import { Product } from '../types';
import { useSettings } from '../contexts/SettingsContext';

interface ProductCardProps {
  product: Product;
  onViewDetails: (product: Product) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, onViewDetails }) => {
  const { ordersEnabled } = useSettings();
  const outOfStock = product.stock === 0;
  const lowStock = product.stock > 0 && product.stock <= 10;

  return (
    <Box
      className="hg-product-card"
      onClick={() => onViewDetails(product)}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        borderRadius: 3,
        overflow: 'hidden',
        backgroundColor: '#fff',
        border: '1px solid rgba(26,20,18,0.06)',
      }}
    >
      <Box sx={{ position: 'relative', overflow: 'hidden', aspectRatio: '4 / 3' }}>
        <Box
          component="img"
          src={product.images[0]}
          alt={product.name}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
        {(outOfStock || lowStock) && (
          <Chip
            label={outOfStock ? 'Rupture' : 'Stock faible'}
            size="small"
            sx={{
              position: 'absolute',
              top: 12,
              left: 12,
              fontWeight: 600,
              backgroundColor: outOfStock ? '#E31E24' : '#c47a1a',
              color: '#fff',
            }}
          />
        )}
      </Box>

      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 1 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontFamily: '"Fraunces", Georgia, serif',
            fontWeight: 600,
            lineHeight: 1.25,
            color: 'text.primary',
          }}
        >
          {product.name}
        </Typography>
        {product.category && (
          <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: '0.04em' }}>
            {product.category}
          </Typography>
        )}
        <Box
          sx={{
            mt: 'auto',
            pt: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              color: 'primary.main',
              fontSize: '1.05rem',
            }}
          >
            {product.price.toLocaleString('fr-FR')} FCFA
          </Typography>
          <Button
            variant="contained"
            size="small"
            disabled={outOfStock || !ordersEnabled}
            onClick={(e) => {
              e.stopPropagation();
              onViewDetails(product);
            }}
            sx={{
              minWidth: 0,
              px: 2,
            }}
          >
            {!ordersEnabled ? 'Indisponible' : outOfStock ? 'Rupture' : 'Voir'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductCard;
